// プロンプトの比較の結果を「期待と違う」「期待どおり」の2つに分ける決め方と、使用中の版の結果の探し方。
// 画面（結果の一覧・ケースを開いたときの比較の結果）はここから引く
import type { DunningSystemPromptVersion } from "../../types"
import { isUnsetTerminal } from "../../terminals"
import { sameTarget } from "./types"
import type { BatchItem, EvaluationBatch } from "./types"

/** 期待する対応が未定のケース。期待どおり・期待と違うのどちらにも数えない（生成に失敗しても） */
export const isUnsetItem = (item: BatchItem) => isUnsetTerminal(item.expectedTerminal)

/** 期待どおり：AI が選んだ対応が期待と一致した（人の対応推奨で本文が I のものを含む） */
export const isExpected = (item: BatchItem) =>
  !isUnsetItem(item) && (item.judgment === "match" || item.judgment === "body_match")

/** 期待と違う：生成を終えて、期待と一致しなかった（生成失敗・人手対応・AIの対応の記録なしを含む）。未完了・未定は含めない */
export const isUnexpected = (item: BatchItem) =>
  !isUnsetItem(item) &&
  (item.judgment === "mismatch" || item.judgment === "no_observation" || item.judgment === "failed")

/** いま使用中の版（督促の既定のプロンプトで有効化されている版） */
export const productionVersion = (versions: DunningSystemPromptVersion[]) =>
  versions.find((version) => version.active && version.promptKey === "dunning_default") ??
  versions.find((version) => version.active)

/**
 * 使用中の版で、表示中の実行と同じ対象を流した最新の完了した実行。
 * 表示中の実行自身が最新なら、それを返す（使用中の版の結果を開いている）
 */
export const autoReference = (
  runs: EvaluationBatch[],
  batch: EvaluationBatch | undefined,
  productionVersionId: number | undefined
) => {
  if (!batch || !productionVersionId) return undefined
  return runs
    .filter(
      (run) =>
        run.status === "completed" &&
        run.promptVersionId === productionVersionId &&
        sameTarget(run.target, batch.target)
    )
    .sort((a, b) => Date.parse(b.startedAt) - Date.parse(a.startedAt))[0]
}
